import { useState, useRef, useEffect } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import Icon from '../Icon';
import './ThemeToggle.css';

const ThemeToggle = () => {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleThemeChange = (newTheme) => {
    setTheme(newTheme);
    setDropdownOpen(false);
  };

  // Get the icon to display based on current theme
  const getThemeIcon = () => {
    if (theme === 'system') {
      return 'monitor';
    }
    return resolvedTheme === 'light' ? 'sun' : 'moon';
  };

  return (
    <div className="theme-toggle-container" ref={dropdownRef}>
      <button
        className="theme-toggle-button"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        aria-label="Toggle theme"
      >
        <Icon 
          name={getThemeIcon()} 
          size={20} 
          color="var(--Text-Body1)" 
        />
      </button>

      {dropdownOpen && (
        <div className="theme-dropdown">
          <div 
            className={`theme-option ${theme === 'light' ? 'active' : ''}`}
            onClick={() => handleThemeChange('light')}
          >
            <Icon name="sun" size={18} color="var(--Text-Body1)" />
            <span>Light</span>
          </div>
          <div 
            className={`theme-option ${theme === 'dark' ? 'active' : ''}`}
            onClick={() => handleThemeChange('dark')}
          >
            <Icon name="moon" size={18} color="var(--Text-Body1)" />
            <span>Dark</span>
          </div>
          <div 
            className={`theme-option ${theme === 'system' ? 'active' : ''}`}
            onClick={() => handleThemeChange('system')}
          >
            <Icon name="monitor" size={18} color="var(--Text-Body1)" />
            <span>System</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ThemeToggle;
